var moduleMap = {
	"./Navigation": function() {
		return Promise.all([__webpack_require__.e(630), __webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(803), __webpack_require__.e(846), __webpack_require__.e(6)]).then(function() { return function() { return (__webpack_require__(2442)); }; });
	},
	"./Footer": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(846), __webpack_require__.e(321)]).then(function() { return function() { return (__webpack_require__(6321)); }; });
	},
	"./ErrorPage": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(567)]).then(function() { return function() { return (__webpack_require__(7567)); }; });
	},
	"./DataGridCellRenderers": function() {
		return Promise.all([__webpack_require__.e(630), __webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(803), __webpack_require__.e(949), __webpack_require__.e(449)]).then(function() { return function() { return (__webpack_require__(8449)); }; });
	},
	"./SBOPTLogo": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(539)]).then(function() { return function() { return (__webpack_require__(9157)); }; });
	},
	"./GenericTable": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(572)]).then(function() { return function() { return (__webpack_require__(4994)); }; });
	},
	"./RecommendationRow": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(87)]).then(function() { return function() { return (__webpack_require__(8087)); }; });
	},
	"./ModifyRecommendationsModal": function() {
		return Promise.all([__webpack_require__.e(630), __webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(803), __webpack_require__.e(949)]).then(function() { return function() { return (__webpack_require__(9324)); }; });
	},
	"./IdleConfirmationModal": function() {
		return Promise.all([__webpack_require__.e(630), __webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(803), __webpack_require__.e(951)]).then(function() { return function() { return (__webpack_require__(2594)); }; });
	},
	"./StyledComponents": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(842)]).then(function() { return function() { return (__webpack_require__(3842)); }; });
	},
	"./ErrorBoundary": function() {
		return Promise.all([__webpack_require__.e(920), __webpack_require__.e(305), __webpack_require__.e(643)]).then(function() { return function() { return (__webpack_require__(2643)); }; });
	},
	"./DatePicker": function() {
		return __webpack_require__.e(596).then(function() { return function() { return (__webpack_require__(596)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});